import React from 'react'

const AdminSupport = () => {
    return (
        <div>
            AdminSupport
        </div>
    )
}

export default AdminSupport
